import read from 'assets/img/read.png';
import flightIcon from 'assets/img/flights.png';
import lodgingIcon from 'assets/img/lodgings.png';
import serviceIcon from 'assets/img/other_services.png';
import packageIcon from 'assets/img/packages.png';
import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';
import moment from 'moment';
import React, { Component } from 'react';
import Avatar from 'react-avatar';
import {
  Grid,
  Badge,
  Col,
  FormControl,
  FormGroup,
  InputGroup,
  Navbar,
  Row,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
// react component for creating dynamic tables
import Board from 'react-trello';
//Redux
import { bindActionCreators } from 'redux';
import Loading from '../../components/Loading';
import auth from '../../libCustom/auth';
import * as QuotationsActions from './redux/QuotationsActions';
import feathers from '../../feathers';
import swal from 'sweetalert';
import Modal from 'react-responsive-modal';
import immutable from 'object-path-immutable';
import {
  getQuotationsLeats,
  getQuotationsTracing,
  getQuotationsSended,
  getQuotationsGuaranteed,
  getQuotationsAchieved,
  getQuotationsDown,
} from './quotationsAdapter';

const CustomCard = (props) => {
  return (
    <div>
      <header
        style={{
          borderBottom: '1px solid #eee',
          padding: 10,
          marginBottom: 10,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          emoji: 'love',
          color: props.cardColor,
        }}
      >
        <div style={{ fontSize: 14, fontWeight: 'bold' }}>{props.title}</div>
        {/* <div style={{ fontSize: 11 }}>          
          <img src={iconsReactions[props.emoji]} alt="" width={20} />
        </div> */}
      </header>

      <div style={{ fontSize: 12 }}>
        <div style={{ padding: '10px' }}>
          <Row>
            <Col lg={3}>
              <Avatar
                name={props.title}
                color={props.color}
                size="40"
                round={true}
              />
            </Col>
            <Col lg={9}>
              <div
                className="pull-right"
                style={{ fontWeight: '600', color: '#457ef7' }}
              >
                {props.index + 1}
              </div>
              <div>{props.description}</div>
              <div>{props.description2}</div>
              <div>{props.description3}</div>
              {(props.laneId === 'guaranteed' || props.laneId === 'achieved' || props.laneId === 'down') && (
                <div>{props.description4}</div>
              )}
              <div>{props.description5}</div>
              {props.description7 && (
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 4,
                    marginTop: 4,
                    padding: '2px 8px',
                    borderRadius: 4,
                    border: '0.5px solid #ddd',
                    backgroundColor: '#f5f5f5',
                    fontSize: 11,
                    color: '#888',
                  }}
                >
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="1"
                      y="3"
                      width="14"
                      height="12"
                      rx="2"
                      stroke="#888"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M5 1v4M11 1v4M1 7h14"
                      stroke="#888"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                  Creado: {moment(props.description7).format('DD/MM/YYYY')}
                </div>
              )}
              {props && (props.laneId === 'leats' || props.laneId === 'sended' || props.laneId === 'tracing')
                && (
                  <div
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 4,
                      marginTop: 4,
                      padding: '2px 8px',
                      borderRadius: 4,
                      border: '0.5px solid #ddd',
                      backgroundColor: '#f5f5f5',
                      fontSize: 11,
                      color: '#888',
                    }}
                  >
                    <svg
                      width="11"
                      height="11"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.5 8a5.5 5.5 0 1 1-1.6-3.89"
                        stroke="#888"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M13.5 2.5v3h-3"
                        stroke="#888"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Actualizado: {props.dateUpdate}
                  </div>
                )}
              <div>{props.description6}</div>
              <div className="pull-right">{props.read}</div>
            </Col>
          </Row>
        </div>
        <div
          style={{
            marginTop: 10,
            textAlign: 'center',
            emoji: 'love',
            color: props.cardColor,
            fontSize: 15,
            fontWeight: 'bold',
          }}
        >
          {props.escalationText}
        </div>
      </div>
    </div>
  );
};

const IconImg = (props) => {
  return (
    <img
      src={props.src}
      style={{
        width: '16%',
        marginRight: '7px',
        marginTop: '5px',
      }}
      alt={props.alt || ''}
    />
  );
};

class QuotationsIndex extends Component {
  constructor(props) {
    super(props);
    this.sellersList = {
      options: [{ value: 'todos', label: 'TODOS LOS AGENTES' }],
    };
    this.state = {
      showModal: false,
      formData: {
        userId:
          auth.getCurrentUser() !== null
            ? {
              value: auth.getCurrentUser().id,
              label: `${auth.getCurrentUser().firstName} ${auth.getCurrentUser().lastName}`,
            }
            : {},
        date: moment().format('L'),
        description: ' ',
        reasonId: null,
        quotationId: null,
      },
      dates: {
        searchFind: false,
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
      },
      boardData: { lanes: [] },
      seller: { label: '', value: '' },
      queryFindClient: null,
      options: [{ value: 'todos', label: 'TODOS LOS AGENTES' }],
      searchFind: false,
      flightFlag: false,
      lodgingFlag: false,
      otherServiceFlag: false,
      packageFlag: false,
      dataAll: [],
      totalAll: [],
      dataArhievedAndDown: [],
      totalArhievedAndDown: 0,
      quotationsLoading: false,
      btnFilter: false,
      showModalDown: false,
      reasonsDown: [],
    };
  }

  async componentDidMount() {
    const { dates, seller } = this.state;

    this.setState({ seller: { label: 'TODOS LOS AGENTES', value: 'todos' } });
    this.getData();

    const findQuery = {
      searchFind: false,
      dateStart: dates.startDate,
      dateEnd: dates.endDate,
    };
    this.componentFind('todos', findQuery);
  }

  componentFind = async (seller, findQuery, silent = false) => {
    if (!silent) {
      this.setState({ quotationsLoading: true });
    }
    try {
      const promises = [
        this.findArhievedAndDown(seller, findQuery),
        this.findQuotationsAll(seller, findQuery),
      ];
      if (!this.state.reasonsDown || this.state.reasonsDown.length === 0) {
        promises.push(this.findReasonsDown());
      }
      await Promise.all(promises);
      await this.showQuotations(seller);
    } catch (error) {
      console.log('error', error);
    } finally {
      if (!silent) {
        this.setState({ quotationsLoading: false });
      }
    }
  };

  findReasonsDown = async () => {
    const reasonsDown = await feathers.service('reasons').find({});
    const options = reasonsDown.data.map((reason) => {
      return {
        value: reason._id,
        label: reason.name,
      };
    });
    this.setState({ reasonsDown: options });
  };

  findArhievedAndDown = async (value, findQuery) => {
    const { franchiseId } = auth.getCurrentUser();
    const { flightFlag, lodgingFlag, otherServiceFlag, packageFlag } = this.state;

    const startDate =
      findQuery && findQuery.searchFind
        ? new Date(findQuery.dateStart)
        : new Date(moment().startOf('month'));
    const endDate =
      findQuery && findQuery.searchFind
        ? new Date(findQuery.dateEnd)
        : new Date(moment().endOf('month'));

    let salesInRange = await feathers.service('sales').find({
      query: {
        franchiseId: franchiseId,
        dateSaleNote: {
          $gte: startDate,
          $lte: endDate,
          $ne: null,
        },
        $select: ['_id', 'dateSaleNote'],
      },
    });

    let saleIds = salesInRange.data.map((sale) => sale._id);

    let query = {
      $populate: [{ path: 'assignedTo' }, { path: 'clientId' }],
      $select: [
        'assignedTo',
        'clientId',
        'franchiseId',
        'status',
        'dates',
        'generalQuotation',
        'flights',
        'lodgings',
        'otherServices',
        'packages',
        'createdAt',
        'createdOn',
        'updatedAt',
        'saleId',
      ],
      franchiseId: franchiseId,
      $or: [
        {
          status: 'down',
          updatedAt: {
            $gte: startDate,
            $lte: endDate,
            $ne: null,
          },
        },
        {
          status: 'down',
          updatedOn: {
            $gte: startDate,
            $lte: endDate,
            $ne: null,
          },
        },
        {
          status: 'achieved',
          saleId: { $in: saleIds },
        },
      ],
    };

    if (flightFlag) {
      query['flights.0'] = { $exists: true };
    } else if (lodgingFlag) {
      query['lodgings.0'] = { $exists: true };
    } else if (otherServiceFlag) {
      query['otherServices.0'] = { $exists: true };
    } else if (packageFlag) {
      query['packages.0'] = { $exists: true };
    }

    const sellerVal = value && value.value !== undefined ? value.value : value;
    if (sellerVal && sellerVal !== 'todos' && typeof sellerVal === 'string') {
      query['assignedTo'] = sellerVal;
    }

    if (franchiseId === '5baa9e4f386a3179c8afae23') {
      query.$sort = {
        createdOn: -1,
      };
    }

    let findResponse = await feathers.service('quotations').find({
      query,
    });

    if (findResponse && findResponse.total > 0) {
      if (value && value.type === 'Client' && value.search !== '') {
        const searchTerm = value.search.trim().toLowerCase();
        const newSearch = findResponse.data.filter((item) => {
          const clientId = item.clientId || {};
          const firstName = (clientId.firstName || '').toLowerCase();
          const lastName = (clientId.lastName || '').toLowerCase();

          return (
            firstName.includes(searchTerm) || lastName.includes(searchTerm)
          );
        });

        findResponse.data = newSearch;
      }

      this.setState({
        totalArhievedAndDown: findResponse.total,
        dataArhievedAndDown: findResponse.data,
      });
    } else {
      this.setState({
        totalArhievedAndDown: 0,
        dataArhievedAndDown: [],
      });
    }
  };

  hasActiveFilters = () => {
    const { flightFlag, lodgingFlag, otherServiceFlag, packageFlag } =
      this.state;

    let textFilter = 'Ninguno';

    if (flightFlag) {
      textFilter = 'Vuelo';
    }
    if (lodgingFlag) {
      textFilter = 'Hospedaje';
    }
    if (otherServiceFlag) {
      textFilter = 'Otros Servicios';
    }
    if (packageFlag) {
      textFilter = 'Paquete';
    }

    return `Filtro activo: ${textFilter}`;
  };

  findQuotationsAll = async (seller, findQuery) => {
    const { franchiseId } = auth.getCurrentUser();
    const { flightFlag, lodgingFlag, otherServiceFlag, packageFlag } = this.state;

    const query = {
      $populate: [{ path: 'assignedTo' }, { path: 'clientId' }, { path: 'generalQuotation.userId' }],
      $select: [
        'assignedTo',
        'clientId',
        'franchiseId',
        'status',
        'dates',
        'read',
        'dateSended',
        'generalQuotation',
        'flights',
        'lodgings',
        'otherServices',
        'packages',
        'createdAt',
        'updatedAt',
        'createdOn',
        'updatedOn',
      ],
      franchiseId: franchiseId,
      status: { $in: ['leats', 'followUp', 'sended', 'guaranteed'] },
      $sort: {
        'dates.departureDate': 1,
      },
    };

    if (franchiseId === '5baa9e4f386a3179c8afae23') {
      query.$sort = {
        createdOn: -1,
      };
    }

    if (findQuery && findQuery.searchFind) {
      const dateStart = new Date(findQuery.dateStart);
      const dateEnd = new Date(findQuery.dateEnd);
      query['$or'] = [
        {
          updatedAt: {
            $gte: dateStart,
            $lte: dateEnd,
          },
        },
        {
          updatedOn: {
            $gte: dateStart,
            $lte: dateEnd,
          },
        },
      ];
    }

    if (flightFlag) {
      query['flights.0'] = { $exists: true };
    } else if (lodgingFlag) {
      query['lodgings.0'] = { $exists: true };
    } else if (otherServiceFlag) {
      query['otherServices.0'] = { $exists: true };
    } else if (packageFlag) {
      query['packages.0'] = { $exists: true };
    }

    const sellerVal = seller && seller.value !== undefined ? seller.value : seller;
    if (sellerVal && sellerVal !== 'todos' && typeof sellerVal === 'string') {
      query['assignedTo'] = sellerVal;
    }

    if (seller && seller.type === 'Client' && seller.search) {
      const clientIds = await this.getClientIdsBySearch(seller.search, franchiseId);

      if (!clientIds || clientIds.length === 0) {
        this.setState({ totalAll: 0, dataAll: [] });
        return;
      }
      query.clientId = { $in: clientIds };
    }

    const findResponse = await feathers.service('quotations').find({
      query,
    });

    this.setState({
      totalAll: findResponse ? findResponse.total : 0,
      dataAll: findResponse ? findResponse.data : [],
    });
  };

  getClientIdsBySearch = async (searchTerm, franchiseId) => {
    if (!searchTerm || searchTerm.trim() === '') return null;

    const regex = { $regex: searchTerm.trim(), $options: 'i' };
    const clientsFound = await feathers.service('clients').find({
      query: {
        franchiseId,
        $or: [{ firstName: regex }, { lastName: regex }],
        $select: ['_id'],
      },
    });

    return clientsFound.data.map((client) => client._id);
  };


  onChange = async (seller) => {
    if (seller) {
      if (seller.value !== 'todos') {
        this.setState({ seller: { label: seller.label, value: seller.value } });
        this.componentFind(seller);
      } else {
        this.setState({ seller: { label: 'TODOS LOS AGENTES', value: '' } });
        this.componentFind('todos');
      }
    } else {
      this.setState({ seller: { label: 'TODOS LOS AGENTES', value: '' } });
      this.componentFind('todos');
    }
  };

  getData = async () => {
    if (auth.getCurrentUser() === null) {
      window.location.href = '/';
    }

    const findUsers = await feathers.service('users').find({
      query: {
        franchiseId: auth.getCurrentUser().franchiseId,
        isDeleted: { $ne: true },
      },
    });

    let options = [{ value: 'todos', label: 'TODOS LOS AGENTES' }];

    if (findUsers.total > 0) {
      findUsers.data.forEach((item) => {
        const nameUser = item.firstName
          ? item.firstName
          : ` ${item.lastName}`
            ? item.lastName
            : '';
        options.push({ value: item._id, label: nameUser });
      });

      if (options.length > 0) {
        options.sort((a, b) => {
          const labelA = a.label.toLowerCase();
          const labelB = b.label.toLowerCase();
          return labelA.localeCompare(labelB);
        });
      }

      this.sellersList.options = options;
    }
  };

  getMonthName = () => {
    const nameMonth = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    const newDate = new Date();
    const month = newDate.getMonth();

    return `${nameMonth[month]}`;
  };

  sordByDates = (values) => {
    let sortValues = values.sort((a, b) => {
      const dateA = new Date(a.dateUpdate);
      const dateB = new Date(b.dateUpdate);

      return dateA - dateB;
    });

    return sortValues;
  };

  sortQuotationByDate = (values) => {
    if (!Array.isArray(values)) return [];
    return values.slice().sort((a, b) => {
      // "Fecha abierta" o sin fecha de salida van al final
      if (a.openDate || !a.departureDate) return 1;
      if (b.openDate || !b.departureDate) return -1;
      // Orden ascendente: fechas más próximas a salir primero
      return new Date(a.departureDate) - new Date(b.departureDate);
    });
  };

  showQuotations = async (seller) => {
    const {
      totalArhievedAndDown,
      dataArhievedAndDown,
      totalAll,
      dataAll,
      flightFlag,
      lodgingFlag,
      otherServiceFlag,
      packageFlag,
    } = this.state;

    const { id, franchiseId } = auth.getCurrentUser();

    const totalData = totalArhievedAndDown + totalAll;

    const mergedData = [
      ...(Array.isArray(dataArhievedAndDown) ? dataArhievedAndDown : []),
      ...(Array.isArray(dataAll) ? dataAll : []),
    ];

    const achievedValues = [];
    const downValues = [];
    const leatsValues = [];
    const sendedValues = [];
    const guaranteedValues = [];
    const tracingValues = [];

    let totalLeats = 0;
    let totalSended = 0;
    let totalGuaranteed = 0;
    let totalTracing = 0;
    let totalArchieved = 0;
    let totalDown = 0;

    if (!flightFlag && !lodgingFlag && !otherServiceFlag && !packageFlag) {
      mergedData.forEach((item) => {
        const { status, dates, generalQuotation } = item;

        if (status === 'achieved') {
          const resultAchieved = getQuotationsAchieved(item);
          achievedValues.push(resultAchieved);
          totalArchieved++;
        }

        if (status === 'down') {
          const resultDown = getQuotationsDown(item);
          downValues.push(resultDown);
          totalDown++;
        }

        if (status === 'leats') {
          if (generalQuotation && generalQuotation.followUp) {
            const resultTracing = getQuotationsTracing(item);
            tracingValues.push(resultTracing);
            totalTracing++;
          } else {
            const resultLeats = getQuotationsLeats(item);
            leatsValues.push(resultLeats);
            totalLeats++;
          }
        }

        if (status === 'sended') {
          if (generalQuotation && generalQuotation.followUp) {
            const resultTracing = getQuotationsTracing(item);
            tracingValues.push(resultTracing);
            totalTracing++;
          } else {
            const resultSended = getQuotationsSended(item);
            sendedValues.push(resultSended);
            totalSended++;
          }
        }

        if (status === 'guaranteed') {
          const resultGuaranteed = getQuotationsGuaranteed(item);
          guaranteedValues.push(resultGuaranteed);
          totalGuaranteed++;
        }
      });
    }

    if (flightFlag) {
      if (totalData > 0) {
        mergedData.forEach((item, index) => {
          const { status, flights, dates, generalQuotation } = item;

          if (flights.length > 0) {
            if (status === 'achieved') {
              const resultAchieved = getQuotationsAchieved(item);
              achievedValues.push(resultAchieved);
            }

            if (status === 'down') {
              const resultDown = getQuotationsDown(item);
              downValues.push(resultDown);
            }

            if (status === 'leats') {
              if (generalQuotation && generalQuotation.followUp) {
                const resultTracing = getQuotationsTracing(item);
                tracingValues.push(resultTracing);
                totalTracing++;
              } else {
                const resultLeats = getQuotationsLeats(item);
                leatsValues.push(resultLeats);
                totalLeats++;
              }
            }

            if (status === 'sended') {
              if (generalQuotation && generalQuotation.followUp) {
                const resultTracing = getQuotationsTracing(item);
                tracingValues.push(resultTracing);
                totalTracing++;
              } else {
                const resultSended = getQuotationsSended(item);
                sendedValues.push(resultSended);
                totalSended++;
              }
            }

            if (status === 'guaranteed') {
              const resultGuaranteed = getQuotationsGuaranteed(item);
              guaranteedValues.push(resultGuaranteed);
              totalGuaranteed++;
            }
          }
        });
      }
    } else if (lodgingFlag) {
      if (totalData > 0) {
        mergedData.forEach((item, index) => {
          const { status, lodgings, dates, generalQuotation } = item;

          if (lodgings.length > 0) {
            if (status === 'achieved') {
              const resultAchieved = getQuotationsAchieved(item);
              achievedValues.push(resultAchieved);
            }

            if (status === 'down') {
              const resultDown = getQuotationsDown(item);
              downValues.push(resultDown);
            }

            if (status === 'leats') {
              if (generalQuotation && generalQuotation.followUp) {
                const resultTracing = getQuotationsTracing(item);
                tracingValues.push(resultTracing);
                totalTracing++;
              } else {
                const resultLeats = getQuotationsLeats(item);
                leatsValues.push(resultLeats);
                totalLeats++;
              }
            }

            if (status === 'sended') {
              if (generalQuotation && generalQuotation.followUp) {
                const resultTracing = getQuotationsTracing(item);
                tracingValues.push(resultTracing);
                totalTracing++;
              } else {
                const resultSended = getQuotationsSended(item);
                sendedValues.push(resultSended);
                totalSended++;
              }
            }

            if (status === 'guaranteed') {
              const resultGuaranteed = getQuotationsGuaranteed(item);
              guaranteedValues.push(resultGuaranteed);
              totalGuaranteed++;
            }
          }
        });
      }
    } else if (otherServiceFlag) {
      if (totalData > 0) {
        mergedData.forEach((item, index) => {
          const { status, otherServices, dates, generalQuotation } = item;

          if (otherServices.length > 0) {
            if (status === 'achieved') {
              const resultAchieved = getQuotationsAchieved(item);
              achievedValues.push(resultAchieved);
            }

            if (status === 'down') {
              const resultDown = getQuotationsDown(item);
              downValues.push(resultDown);
            }

            if (status === 'leats') {
              if (generalQuotation && generalQuotation.followUp) {
                const resultTracing = getQuotationsTracing(item);
                tracingValues.push(resultTracing);
                totalTracing++;
              } else {
                const resultLeats = getQuotationsLeats(item);
                leatsValues.push(resultLeats);
                totalLeats++;
              }
            }

            if (status === 'sended') {
              if (generalQuotation && generalQuotation.followUp) {
                const resultTracing = getQuotationsTracing(item);
                tracingValues.push(resultTracing);
                totalTracing++;
              } else {
                const resultSended = getQuotationsSended(item);
                sendedValues.push(resultSended);
                totalSended++;
              }
            }

            if (status === 'guaranteed') {
              const resultGuaranteed = getQuotationsGuaranteed(item);
              guaranteedValues.push(resultGuaranteed);
              totalGuaranteed++;
            }
          }
        });
      }
    } else if (packageFlag) {
      if (totalData > 0) {
        mergedData.forEach((item, index) => {
          const { status, packages, dates, generalQuotation } = item;

          if (packages.length > 0) {
            if (status === 'achieved') {
              const resultAchieved = getQuotationsAchieved(item);
              achievedValues.push(resultAchieved);
            }

            if (status === 'down') {
              const resultDown = getQuotationsDown(item);
              downValues.push(resultDown);
            }

            if (status === 'leats') {
              if (generalQuotation && generalQuotation.followUp) {
                const resultTracing = getQuotationsTracing(item);
                tracingValues.push(resultTracing);
                totalTracing++;
              } else {
                const resultLeats = getQuotationsLeats(item);
                leatsValues.push(resultLeats);
                totalLeats++;
              }
            }

            if (status === 'sended') {
              if (generalQuotation && generalQuotation.followUp) {
                const resultTracing = getQuotationsTracing(item);
                tracingValues.push(resultTracing);
                totalTracing++;
              } else {
                const resultSended = getQuotationsSended(item);
                sendedValues.push(resultSended);
                totalSended++;
              }
            }

            if (status === 'guaranteed') {
              const resultGuaranteed = getQuotationsGuaranteed(item);
              guaranteedValues.push(resultGuaranteed);
              totalGuaranteed++;
            }
          }
        });
      }
    }

    const archievedPercentage =
      totalArhievedAndDown > 0
        ? ((totalArchieved / totalArhievedAndDown) * 100).toFixed(1)
        : 0;
    const downPercentage =
      totalArhievedAndDown > 0
        ? ((totalDown / totalArhievedAndDown) * 100).toFixed(1)
        : 0;

    let letsSortd = leatsValues;
    let tracingSortd = tracingValues;
    let sendedSortd = sendedValues;
    let guaranteedSortd = guaranteedValues;
    let achievedSortd = achievedValues;
    let downSortd = downValues;

    if (franchiseId !== '5baa9e4f386a3179c8afae23') {
      tracingSortd = this.sordByDates(tracingValues);
      sendedSortd = this.sortQuotationByDate(sendedValues);
    }

    let quotations = {
      lanes: [
        {
          id: 'leats',
          title: 'Prospectos',
          label: `${totalLeats} / ${totalData}`,
          cards: letsSortd,
        },
        {
          id: 'tracing',
          title: 'Seguimiento',
          label: `${totalTracing} / ${totalData}`,
          cards: tracingSortd,
        },
        {
          id: 'sended',
          title: 'Enviados',
          label: `${totalSended} / ${totalData}`,
          cards: sendedSortd,
        },
        {
          id: 'guaranteed',
          title: 'Garantizados',
          label: `${totalGuaranteed} / ${totalData}`,
          cards: guaranteedSortd,
        },
        {
          id: 'achieved',
          title: 'Logrados',
          label: (
            <div>
              <div style={{ fontSize: '12px' }}>
                <strong>Mes Actual:</strong> {this.getMonthName()}
              </div>
              <div style={{ fontSize: '12px' }}>
                {totalArchieved} / {totalData}
              </div>
            </div>
          ),
          cards: achievedSortd,
        },
        {
          id: 'down',
          title: 'Caídas',
          label: (
            <div>
              <div style={{ fontSize: '12px' }}>
                <strong> Mes Actual:</strong> {this.getMonthName()}
              </div>
              <div style={{ fontSize: '12px' }}>
                {totalDown} / {totalData}
              </div>
            </div>
          ),
          cards: downSortd,
        },
      ],
    };
    this.setState({ boardData: quotations });
  };

  handleCardId = (card, laneId) => {
    window.open('/#/admin/quotations/' + card, '_blank');
  };

  handleDragEnd = async (cardId, sourceLaneId, targetLaneId) => {
    const _this = this;
    if (
      (sourceLaneId === 'leats' ||
        sourceLaneId === 'tracing' ||
        sourceLaneId === 'sended' ||
        sourceLaneId === 'guaranteed') &&
      targetLaneId === 'down'
    ) {
      if (auth && auth.can('fallManager')) {
        _this.setState({
          showModalDown: true,
          formData: {
            ..._this.state.formData,
            quotationId: cardId,
          },
        });
        return;
      } else {
        await swal(
          'Acceso denegado',
          'Solo los administradores pueden realizar esta acción',
          {
            icon: 'warning',
            timer: 2000,
            buttons: false,
          },
        );
      }
    } else if (sourceLaneId === 'leats' && targetLaneId === 'sended') {
      await feathers.service('quotations').patch(cardId, {
        status: 'sended',
        dateSended: moment(),
      });
      await swal('Éxito', 'Cotización actualizada correctamente', {
        icon: 'success',
        timer: 900,
        buttons: false,
      });
    } else if (sourceLaneId === 'sended' && targetLaneId === 'leats') {
      await feathers.service('quotations').patch(cardId, {
        status: 'leats',
      });
      await swal('Éxito', 'Cotización actualizada correctamente', {
        icon: 'success',
        timer: 900,
        buttons: false,
      });
    } else if (sourceLaneId === 'leats' && targetLaneId === 'tracing') {
      await feathers.service('quotations').patch(cardId, {
        'generalQuotation.followUp': true,
      });

      await swal('Éxito', 'Cotización actualizada correctamente', {
        icon: 'success',
        timer: 900,
        buttons: false,
      });
    } else if (sourceLaneId === 'tracing' && targetLaneId === 'leats') {
      await feathers.service('quotations').patch(cardId, {
        'generalQuotation.followUp': false,
        status: 'leats',
      });

      await swal('Éxito', 'Cotización actualizada correctamente', {
        icon: 'success',
        timer: 900,
        buttons: false,
      });
    } else if (sourceLaneId === 'tracing' && targetLaneId === 'sended') {
      await feathers.service('quotations').patch(cardId, {
        'generalQuotation.followUp': false,
        status: 'sended',
        dateSended: moment(),
      });
      await swal('Éxito', 'Cotización actualizada correctamente', {
        icon: 'success',
        timer: 900,
        buttons: false,
      });
    } else if (sourceLaneId === 'sended' && targetLaneId === 'tracing') {
      await feathers.service('quotations').patch(cardId, {
        'generalQuotation.followUp': true,
      });
      await swal('Éxito', 'Cotización actualizada correctamente', {
        icon: 'success',
        timer: 900,
        buttons: false,
      });
    } else if (sourceLaneId === 'down') {
      console.log({ sourceLaneId, targetLaneId, cardId });
      if (targetLaneId == 'tracing') {
        await feathers.service('quotations').patch(cardId, {
          'generalQuotation.followUp': true,
          status: 'leats',
        });
      } else {
        await feathers.service('quotations').patch(cardId, {
          'generalQuotation.followUp': false,
          status: targetLaneId,
        });
      }

      await swal('Éxito', 'Cotización actualizada correctamente', {
        icon: 'success',
        timer: 900,
        buttons: false,
      });
    }

    this.refreshCardData();
  };

  refreshCardData = () => {
    const {
      seller,
      searchFind,
      dates: { startDate, endDate },
      queryFindClient,
    } = this.state;

    let agent = 'todos';
    if (seller) {
      agent = seller;
    }

    let findQuery = null;
    if (searchFind) {
      findQuery = {
        searchFind: true,
        dateStart: startDate,
        dateEnd: endDate,
      };
    }

    if (
      queryFindClient &&
      queryFindClient.type &&
      queryFindClient.type === 'Client' &&
      queryFindClient.search
    ) {
      agent = queryFindClient;
    }

    this.componentFind(agent, findQuery, false);
  };

  findQuotationsReport = async () => {
    const { dates, seller, searchFind } = this.state;

    let findQuery = {
      searchFind: true,
      dateStart: dates.startDate,
      dateEnd: dates.endDate,
    };

    this.componentFind(seller, findQuery);
  };

  resetSearchByDate = async () => {
    const { seller } = this.state;
    this.setState({
      dates: {
        searchFind: false,
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
      },
    });
    this.componentFind(seller, 'todos');
  };

  getFlights = async () => {
    this.setState(
      {
        flightFlag: true,
        lodgingFlag: false,
        otherServiceFlag: false,
        packageFlag: false,
      },
      () => {
        this.componentFind(this.state.seller);
      }
    );
  };

  getLodgings = async () => {
    this.setState(
      {
        flightFlag: false,
        lodgingFlag: true,
        otherServiceFlag: false,
        packageFlag: false,
      },
      () => {
        this.componentFind(this.state.seller);
      }
    );
  };

  getOtherServices = async () => {
    this.setState(
      {
        flightFlag: false,
        lodgingFlag: false,
        otherServiceFlag: true,
        packageFlag: false,
      },
      () => {
        this.componentFind(this.state.seller);
      }
    );
  };

  getPackages = async () => {
    this.setState(
      {
        flightFlag: false,
        lodgingFlag: false,
        otherServiceFlag: false,
        packageFlag: true,
      },
      () => {
        this.componentFind(this.state.seller);
      }
    );
  };

  resetFlags = async () => {
    this.setState({
      flightFlag: false,
      lodgingFlag: false,
      otherServiceFlag: false,
      packageFlag: false,
      searchFind: false,
    });

    const findQuery = {
      searchFind: false,
      dateStart: '',
      dateEnd: '',
    };
    await this.componentFind(this.state.seller, findQuery);
  };

  onChangeDate = (path, value) => {
    var newDates;
    if (value) {
      newDates = immutable.set(this.state.dates, path, value);
      this.setState({
        dates: newDates,
        selectedDate: true,
      });
    } else {
      newDates = immutable.set(this.state.dates, path, value);
      this.setState({
        dates: newDates,
        selectedDate: false,
      });
    }
  };

  searchTable = (search) => {
    const findQuery = {
      type: 'Client',
      search,
    };

    this.setState({
      queryFindClient: findQuery,
    });

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    this.searchTimer = setTimeout(() => {
      this.componentFind(findQuery, null);
    }, 350);
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: selectedOption,
      },
    }));
  };

  handleSave = async () => {
    const { formData } = this.state;

    if (!formData.reasonId) {
      alert('Por favor selecciona una causa.');
      return;
    }
    try {
      const { date, description, quotationId, reasonId, userId } =
        this.state.formData;

      const insertObject = {
        reasonId: reasonId.value,
        description,
        userId: userId.value,
        date,
        quotationId: quotationId,
      };

      const createFalling = await feathers
        .service('falling-quotes')
        .create(insertObject);

      if (createFalling && createFalling._id) {
        await feathers.service('quotations').patch(quotationId, {
          status: 'down',
        });

        await swal('Éxito', 'Cotización actualizada correctamente', {
          icon: 'success',
          timer: 900,
          buttons: false,
        });
        this.setState({ showModalDown: false });
        this.refreshCardData();
      }
    } catch (error) {
      console.error('Error al guardar:', error);
    }
  };

  render() {
    const { history } = this.props;
    const {
      flightFlag,
      lodgingFlag,
      otherServiceFlag,
      packageFlag,
      seller: { value },
      showModal,
      dates,
      searchFind,
      showModalDown,
      reasonsDown,
    } = this.state;

    const reportQuotationFeathersURL = `${process.env.REACT_APP_URL_FEATHERS
      }/quotations-board-report/?flightFilter=${flightFlag}&hotelfilter=${lodgingFlag}&packageFilter=${packageFlag}&otherFilter=${otherServiceFlag}&franchiseId=${auth.getCurrentUser().franchiseId
      }${value !== 'todos' && value !== '' ? `&assignedTo=${value}` : ''
      }&startDate=${dates.startDate}&endDate=${dates.endDate}`;

    return (
      <div className="main-content">
        <Modal
          open={showModal}
          onClose={() => {
            this.setState({ showModal: false });
          }}
          styles={{
            modal: { width: '580px', zIndex: 3000 },
            overlay: { alignItems: 'flex-start', zIndex: 2999 },
          }}
          closeOnOverlayClick={false}
        >
          <Grid fluid>
            <Col md={12}>
              <Row style={{ marginTop: '32px' }}>
                <div className="pull-left">
                  <div
                    style={{
                      fontSize: '24px',
                      marginBottom: '16px',
                      textAlign: 'center',
                    }}
                  >
                    Reporte Cotizaciones
                  </div>
                  <label style={{ fontWeight: '250' }}>Desde :</label>
                  <input
                    style={{ color: '#000000', marginBottom: '16px' }}
                    type="date"
                    className="form-control"
                    value={dates.startDate}
                    onChange={(event) =>
                      this.onChangeDate('startDate', event.target.value)
                    }
                  />
                  <label style={{ fontWeight: '250' }}>Hasta :</label>
                  <input
                    style={{ color: '#000000', marginBottom: '48px' }}
                    type="date"
                    className="form-control"
                    value={dates.endDate}
                    onChange={(event) =>
                      this.onChangeDate('endDate', event.target.value)
                    }
                  />
                  <Button
                    bsStyle="primary"
                    style={{ marginBottom: '32px', marginLeft: '370px' }}
                    wd
                    href={reportQuotationFeathersURL}
                  >
                    Descargar Reporte
                  </Button>
                </div>
              </Row>
            </Col>
          </Grid>
        </Modal>

        <Modal
          open={showModalDown}
          onClose={() => this.setState({ showModalDown: false })}
          styles={{
            modal: { width: '100%' },
            overlay: { alignItems: 'flex-start', zIndex: 2999 },
          }}
          closeOnOverlayClick={false}
        >
          <form
            ref={(ref) => {
              this.formFalling = ref;
            }}
          >
            <div>
              <Grid fluid>
                <Row>
                  <Col md={12}>
                    <h5>Cotización caída</h5>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label
                        htmlFor="responsable"
                        style={{ fontWeight: '400' }}
                      >
                        Responsable
                      </label>
                      <Select
                        placeholder="-- Seleccionar"
                        name="userId"
                        value={this.state.formData.userId}
                        disabled={true}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label htmlFor="date" style={{ fontWeight: '400' }}>
                        Fecha
                      </label>
                      <input
                        id="date"
                        className="form-control"
                        value={this.state.formData.date}
                        disabled={true}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label htmlFor="reasonId" style={{ fontWeight: '400' }}>
                        Causa
                      </label>
                      <Select
                        required
                        placeholder="-- Seleccionar"
                        name="reasonId"
                        options={reasonsDown}
                        value={this.state.formData.reasonId}
                        onChange={(selectedOption) =>
                          this.handleSelectChange('reasonId', selectedOption)
                        }
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label
                        htmlFor="description"
                        style={{ fontWeight: '400' }}
                      >
                        Descripción
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="description"
                        name="description"
                        value={this.state.formData.description}
                        onChange={this.handleChange}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <div className={'pull-right'} style={{ marginBottom: 15 }}>
                      <Button bsStyle="primary" style={{ marginRight: 10 }}>
                        Regresar
                      </Button>
                      <Button bsStyle="primary" fill onClick={this.handleSave}>
                        Guardar
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </div>
          </form>
        </Modal>

        <Row>
          <Col md={12}>{/* <CardsQ /> */}</Col>
          <Col md={12}>
            <Card
              title={
                <div>
                  <div>
                    <div className="pull-left header-table">
                      <Navbar.Form
                        pullLeft
                        className="navbar-search-form"
                        style={{ minWidth: 300 }}
                      >
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>
                            <FormControl
                              type="text"
                              placeholder="Buscar por cliente, folio, destino, interes..."
                              onChange={(event) =>
                                this.searchTable(event.target.value)
                              }
                            />
                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                    </div>

                    <div className="pull-left header-table">
                      <div className="form-group">
                        <Select
                          style={{ width: 400, fontSize: 18 }}
                          wrapperStyle={{ zIndex: 2000 }}
                          menuStyle={{ fontSize: 18 }}
                          placeholder="-- seleccionar vendedor --"
                          name="seller"
                          value={this.state.seller}
                          options={this.sellersList.options}
                          onChange={(seller) => this.onChange(seller)}
                        />
                      </div>
                    </div>

                    <div className="pull-left">
                      <div className="form-group">
                        <Button
                          bsStyle="primary"
                          style={{ marginBottom: '32px', marginLeft: '40px' }}
                          wd
                          onClick={() =>
                            this.setState({
                              showModal: true,
                            })
                          }
                        >
                          Descargar Tablero Cotizaciones
                        </Button>
                      </div>
                    </div>

                    <div className="pull-right header-table">
                      <Button
                        bsStyle="primary"
                        wd
                        onClick={() => history.push('/admin/quotations/create')}
                      >
                        Agregar Cotización
                      </Button>
                    </div>

                    <div className="clearfix" />
                  </div>

                  <div
                    className="header-table"
                    style={{ marginBottom: '10px' }}
                  >
                    <Button
                      bsStyle="primary"
                      wd
                      onClick={() =>
                        this.setState({ btnFilter: !this.state.btnFilter })
                      }
                    >
                      {this.state.btnFilter
                        ? 'Menos Filtros ▲'
                        : 'Mas Filtros ▼'}
                    </Button>
                  </div>

                  {this.state.btnFilter && (
                    <div>
                      <div
                        className="header-table"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          marginBottom: '15px',
                        }}
                      >
                        <label style={{ fontWeight: '250' }}>Desde :</label>
                        <input
                          id="dateStart"
                          type="date"
                          value={dates.startDate}
                          style={{ color: '#000000', width: '15%' }}
                          className="form-control"
                          onChange={(event) =>
                            this.onChangeDate('startDate', event.target.value)
                          }
                        />
                        <label style={{ fontWeight: '250' }}>Hasta :</label>
                        <input
                          id="dateEnd"
                          type="date"
                          value={dates.endDate}
                          style={{ color: '#000000', width: '15%' }}
                          className="form-control"
                          onChange={(event) =>
                            this.onChangeDate('endDate', event.target.value)
                          }
                        />

                        <div>
                          <Button
                            bsStyle="primary"
                            wd
                            onClick={this.findQuotationsReport}
                          >
                            {/*searchFind ? 'Mostrar Todos' : 'Buscar'}*/}
                            Buscar
                          </Button>
                        </div>

                        <div>
                          <Button
                            bsStyle="default"
                            wd
                            onClick={this.resetSearchByDate}
                          >
                            Restablecer
                          </Button>
                        </div>
                      </div>

                      <div>
                        <Row>
                          <Col
                            md={2}
                            sm={3}
                            xs={12}
                            style={{ textAlign: 'center' }}
                          >
                            <Button
                              style={{
                                borderColor: 'transparent',
                                fontSize: '14px',
                              }}
                              onClick={this.getFlights}
                            >
                              <img
                                src={flightIcon}
                                style={{ width: '35px', marginRight: '5px' }}
                              />
                              Vuelo
                            </Button>
                          </Col>
                          <Col
                            md={2}
                            sm={3}
                            xs={12}
                            style={{ textAlign: 'center' }}
                          >
                            <Button
                              style={{
                                borderColor: 'transparent',
                                fontSize: '14px',
                              }}
                              onClick={this.getLodgings}
                            >
                              <img
                                src={lodgingIcon}
                                style={{
                                  width: '35px',
                                  marginRight: '5px',
                                }}
                              />
                              Hotel
                            </Button>
                          </Col>
                          <Col
                            md={2}
                            sm={3}
                            xs={12}
                            style={{ textAlign: 'center' }}
                          >
                            <Button
                              style={{
                                borderColor: 'transparent',
                                fontSize: '14px',
                              }}
                              onClick={this.getPackages}
                            >
                              <img
                                src={packageIcon}
                                style={{ width: '35px', marginRight: '5px' }}
                              />
                              Paquete
                            </Button>
                          </Col>
                          <Col
                            md={2}
                            sm={3}
                            xs={12}
                            style={{ textAlign: 'center' }}
                          >
                            <Button
                              style={{
                                borderColor: 'transparent',
                                fontSize: '14px',
                              }}
                              onClick={this.getOtherServices}
                            >
                              <img
                                src={serviceIcon}
                                style={{ width: '35px', marginRight: '5px' }}
                              />
                              Otro
                            </Button>
                          </Col>

                          <Col
                            md={3}
                            sm={12}
                            xs={12}
                            style={{
                              textAlign: 'center',
                              marginTop: '8px',
                            }}
                          >
                            <span
                              style={{
                                fontSize: '14px',
                              }}
                            >
                              {this.hasActiveFilters()}
                            </span>
                            <Button
                              style={{
                                width: '5%',
                                marginRight: '1px',
                                borderColor: '#fff',
                                color: 'red',
                              }}
                              onClick={this.resetFlags}
                            >
                              <i
                                style={{
                                  fontSize: 22,
                                  color: 'red',
                                }}
                                className="fa fa-times"
                              />
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </div>
              }
              ctFullWidth
              content={
                this.state.quotationsLoading ? (
                  <Loading />
                ) : (
                  <Board
                    data={this.state.boardData}
                    onCardClick={this.handleCardId}
                    style={{
                      backgroundColor: 'white',
                    }}
                    cardStyle={{ backgroundColor: 'white' }}
                    customCardLayout
                    draggable
                    handleDragStart={this.handleDragStart}
                    handleDragEnd={this.handleDragEnd}
                  >
                    <CustomCard />
                  </Board>
                )
              }
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Quotations: state.Quotations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(QuotationsActions, dispatch);
};

const QuotationsConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuotationsIndex);

export default QuotationsConnect;



// WEBPACK FOOTER //
// ./src/views/Quotations/QuotationsIndex.jsx